// store/audio.js
export default {
  namespaced: true,  // 使用命名空间
  
  state: {
    // 播放状态
    isPlaying: false,
    // 当前播放的音乐URL
    currentUrl: 'https://mk.chinaman.cn/mybigdatas/sy/%E8%83%8C%E6%99%AF%E9%9F%B3%E4%B9%90.mp3',
    // 音频实例
    audio: null,
    // 播放进度
    currentTime: 0,
    // 音乐总时长
    duration: 0,
    // 音量
    volume: 1,
    // 播放模式 0: 顺序 1: 单曲循环 2: 随机
    playMode: 1
  },

  mutations: {
    // 设置播放状态
    SET_PLAYING(state, status) {
      state.isPlaying = status
    },
    // 设置当前音乐URL
    SET_CURRENT_URL(state, url) {
      state.currentUrl = url
    },
    // 设置音频实例
    SET_AUDIO(state, audio) {
      state.audio = audio
    },
    // 更新播放进度
    SET_CURRENT_TIME(state, time) {
      state.currentTime = time
    },
    // 设置音乐总时长
    SET_DURATION(state, duration) {
      state.duration = duration
    },
    // 设置音量
    SET_VOLUME(state, volume) {
      state.volume = volume
    },
    // 设置播放模式
    SET_PLAY_MODE(state, mode) {
      state.playMode = mode
    }
  },

  actions: {
    // 初始化音频
    initAudio({ commit, state }, url) {
      if (!state.audio) {
        const audio = new Audio()
        commit('SET_AUDIO', audio)
        
        // 监听音乐加载完成
        audio.addEventListener('loadedmetadata', () => {
          commit('SET_DURATION', audio.duration)
        })
        
        // 监听播放进度更新
        audio.addEventListener('timeupdate', () => {
          commit('SET_CURRENT_TIME', audio.currentTime)
        })
        
        // 监听音乐播放结束
        audio.addEventListener('ended', () => {
          commit('SET_PLAYING', false)
        })
      }
      
      if (url !== state.currentUrl) {
        state.audio.src = url
        commit('SET_CURRENT_URL', url)
      }
    },

    // 播放音乐
    play({ commit, state }) {
      if (state.audio) {
        state.audio.play()
        commit('SET_PLAYING', true)
      }
    },

    // 暂停音乐
    pause({ commit, state }) {
      if (state.audio) {
        state.audio.pause()
        commit('SET_PLAYING', false)
      }
    },

    // 切换播放/暂停
    togglePlay({ dispatch, state }) {
      if (state.isPlaying) {
        dispatch('pause')
      } else {
        dispatch('play')
      }
    },

    // 设置播放进度
    setCurrentTime({ state }, time) {
      if (state.audio) {
        state.audio.currentTime = time
      }
    },

    // 设置音量
    setVolume({ commit, state }, volume) {
      if (state.audio) {
        state.audio.volume = volume
        commit('SET_VOLUME', volume)
      }
    },

    // 切换播放模式
    togglePlayMode({ commit, state }) {
      const nextMode = (state.playMode + 1) % 3
      commit('SET_PLAY_MODE', nextMode)
    }
  },

  getters: {
    // 获取播放进度百分比
    progressPercent: state => {
      return state.duration ? (state.currentTime / state.duration) * 100 : 0
    },
    // 格式化当前时间
    formattedCurrentTime: state => {
      const minutes = Math.floor(state.currentTime / 60)
      const seconds = Math.floor(state.currentTime % 60)
      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    },
    // 格式化总时长
    formattedDuration: state => {
      const minutes = Math.floor(state.duration / 60)
      const seconds = Math.floor(state.duration % 60)
      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/music.js